module.exports = __webpack_public_path__ + "img/features-icon.d3835486.svg";